<div #trigger (click)="toggleDropdown()" class="value-box text-content" [class.selection-open]="showDropdown" [class.has-selection]="!isEmpty()">
	@if (isEmpty()) {
		<div class="placeholder">Map selecteren</div>
	} @else {
		<div class="selected-value" [title]="value!.naam">{{ value!.naam }}</div>
	}
	@if (showDropdown || isEmpty()) {
		<app-icon
			[name]="showDropdown ? 'chevron-up' : 'chevron-down'"
			size="small"
			class="chevron-icon"
			[color]="showDropdown ? 'primary-1' : 'typography-5'"
			hoverColor="primary-1"
		></app-icon>
	}
	@if (!showDropdown && !isEmpty()) {
		<app-icon name="sluiten" size="medium" class="chevron-icon" color="primary-1" hoverColor="primary-2" (click)="remove($event)"></app-icon>
	}
</div>
<ng-template #dropdown>
	<div class="selection-box">
		@for (optie of mappen; track optie) {
			<div class="optie" [class.is-selected]="isSelected(optie)" (click)="select(optie)">
				<app-icon name="folder" size="small" color="typography-5"></app-icon>
				<span class="optie-text text-content">{{ optie.naam }}</span>
			</div>
		}
		@if (editing) {
			<div class="editing">
				<app-immediate-input [init]="template.naam" (done)="create($event)"></app-immediate-input>
			</div>
		}
		<div class="optie nieuwe-map" (click)="editing = true">
			<app-icon name="toevoegen" color="primary-1" size="small"></app-icon>
			<span class="optie-text text-content nieuwe-map-tekst">Nieuwe map</span>
		</div>
	</div>
</ng-template>
